/**
 * App logo（地瓜），與 `public/app-icon.svg` 同一份幾何。
 *
 * 刻意內嵌而不是 `<img src="/app-icon.svg">`：它最主要的用途是載入畫面，
 * 而那正是連 icon 都還沒到手的時刻——外部檔案會先空一格再跳出來，等於在等待
 * 畫面裡又加了一次閃動。
 *
 * 兩處幾何若要調整，請一起改；`app-icon.svg` 那份帶有完整的形狀註解。
 */

import { useId } from 'react';

interface AppLogoProps {
  size?: number;
  className?: string;
}

export function AppLogo({ size = 64, className }: AppLogoProps) {
  /* 同一頁可能出現兩個 logo，葉子的 id 必須跟著實例走，否則 <use> 會指到別人的 */
  const leafId = useId();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 128 128"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <g transform="translate(64 64)">
        <g transform="rotate(-35)">
          <path
            d="M-46 4
               C -44 -14, -22 -26, 2 -26
               C 26 -26, 46 -16, 46 -4
               C 46 12, 24 26, 0 26
               C -24 26, -48 20, -46 4 Z"
            fill="#946C09"
          />
        </g>
        <g transform="translate(-7 -27) rotate(-9) scale(0.95)">
          <g id={leafId} transform="rotate(14)">
            <g transform="rotate(-22) scale(1 1.35) rotate(22)">
              <path
                d="M0 2 C -7 -8, -19 -11, -23 -8 C -27 -4, -21 5, -10 5 C -5 5, -2 4, 0 2 Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <use href={`#${leafId}`} transform="scale(-0.86 0.86)" />
        </g>
      </g>
    </svg>
  );
}
